








import { HTTP } from "../constants/constant";
import { Prop, Component, Vue } from "vue-property-decorator";

@Component
export default class ErrorView extends Vue {
  
  @Prop({ required: true })
  readonly isVisibleError!: boolean;
  @Prop({ required: true })
  private message: string = "";
  @Prop({ required: true })
  private status: number = 0;

  private getErrorMessage(): string {
    if (HTTP.STATUS.MESSAGE[this.status]) {
      // 定数リストに存在するステータスの場合には、該当のメッセージを返す。
      return HTTP.STATUS.MESSAGE[this.status];
    } else {
      // 定数リストに存在しない場合には、デフォルトのメッセージを返す。
      return HTTP.STATUS.MESSAGE[HTTP.STATUS.DEFAULT];
    }
  }
}
